"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLaunchRequest = void 0;
const platform_sdk_1 = require("@pureweb/platform-sdk");
const react_1 = require("react");
exports.useLaunchRequest = (platform, md, options) => {
    const [statusEvent, setStatusEvent] = react_1.useState({
        status: platform_sdk_1.LaunchStatusType.Unknown
    });
    const [launchRequest, setLaunchRequest] = react_1.useState();
    const launchFunc = react_1.useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (md == undefined) {
            return;
        }
        const regionOverride = options.regionOverride;
        const virtualizationProviderOverride = options.virtualizationProviderOverride;
        const lr = yield platform.requestModel(md, regionOverride, virtualizationProviderOverride);
        setLaunchRequest(lr);
    }), [platform, md]);
    // Listen for status updates
    react_1.useEffect(() => {
        window.addEventListener('beforeunload', () => __awaiter(void 0, void 0, void 0, function* () {
            if (launchRequest == null) {
                return;
            }
            if (launchRequest.status.getValue().status !== platform_sdk_1.LaunchStatusType.Serviced &&
                launchRequest.status.getValue().status !== platform_sdk_1.LaunchStatusType.Error &&
                launchRequest.status.getValue().status !== platform_sdk_1.LaunchStatusType.Unavailable &&
                launchRequest.status.getValue().status !== platform_sdk_1.LaunchStatusType.ModelError) {
                yield launchRequest.cancel();
            }
        }));
        if (launchRequest == null) {
            return;
        }
        const subscription = launchRequest.status.subscribe((statusEvent) => {
            try {
                setStatusEvent(statusEvent);
            }
            catch (err) {
                setStatusEvent({ status: platform_sdk_1.LaunchStatusType.Error, message: err });
            }
        }, (err) => {
            setStatusEvent({ status: platform_sdk_1.LaunchStatusType.Error, message: err });
        });
        return () => {
            subscription.unsubscribe();
        };
    }, [launchRequest]);
    return [statusEvent, launchRequest, launchFunc];
};
//# sourceMappingURL=LaunchRequestHook.js.map